import { render, staticRenderFns } from "./EmployeeConcernTable.vue?vue&type=template&id=0f977462&scoped=true"
import script from "./EmployeeConcernTable.vue?vue&type=script&lang=js"
export * from "./EmployeeConcernTable.vue?vue&type=script&lang=js"
import style0 from "./EmployeeConcernTable.vue?vue&type=style&index=0&id=0f977462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f977462",
  null
  
)

export default component.exports